import json from '../../json'
import router from '@/router/index'

// initial state
const state = {
  status: '',
  areas: [],
  area: undefined,
  areaId: 0,
  lineInfo: {},
  loadedAt: new Date(),
  error: ''
}

// getters
const getters = {
  error: state => state.error,
  areas: state => state.areas,
  areaId: state => state.areaId,
  lineInfo: state => state.lineInfo,
  status: state => state.status,
  loadedAt: state => state.loadedAt
}

// actions
const actions = {
  all ({ commit, state }) {
    if (state.status === 'init') {
      // すでにローディング済みの場合
      commit('setStatus', '')
      setTimeout(() => {
        commit('setStatus', 'init')
      })
    } else {
      commit('setStatus', '')
      json.get('/ope/master/mst_area_line.json', undefined, true)
        .then(response => {
          commit('setAreas', response.data)
        })
        .catch(() => {
          router.push({ name: 'PageNotFound' })
        })
    }
  },
  setLineInfo ({ commit, state }, params) {
    commit('setLineInfo', params)
  },
  setAreaId ({ commit, state }, areaId) {
    commit('setAreaId', areaId)
  },
  reload ({ commit, state }) {
    commit('reload')
  }
}

// mutations
const mutations = {
  setStatus (state, data) {
    state.status = data
  },
  setAreas (state, data) {
    state.areas = data.areas
    state.status = 'init'
  },
  setLineInfo (state, params) {
    if (state.areas) {
      const lines = state.areas.filter((area) => area.area_id === params.areaId)[0].lines
      state.lineInfo = lines.filter((line) => line.line_id === params.lineId)[0]
    }
  },
  setAreaId (state, areaId) {
    if (areaId === 0) {
      state.areaId = 0
      state.area = undefined
    } else {
      state.areaId = parseInt(areaId, 10)
      state.area = state.areas.find(area => area.area_id === state.areaId)
    }
  },
  setError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = 'サーバーに接続できません。'
    }
    state.status = 'error'
  },
  reload (state) {
    state.loadedAt = new Date()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/areaLine.js